module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starEmpty@3x-d00d58d59146d870e8feb0db006be353.png";